module.exports = __webpack_public_path__ + "img/title.854a137e.png";